<script setup lang="ts">
import { onMounted } from 'vue'
import { BaseTabs } from '@/components/base'
import { useNavigator } from '@/hooks'
import {
  DIGESTATE_JOBS_BASE_URL,
  DIGESTATE_JOBS_URL,
  HAULAGE_JOBS_BASE_URL
} from '@/utils/constants'
import { TransportJobsType } from '@/enum'
import { useRoute } from 'vue-router'
import useGlobalStore from '@/stores/modules/global'

const globalStore = useGlobalStore()
const navigator = useNavigator()

const tabs = [
  {
    label: TransportJobsType.Haulage,
    action: () => navigator.navigateTo(HAULAGE_JOBS_BASE_URL)
  },
  {
    label: TransportJobsType.Digestate,
    action: () => navigator.navigateTo(DIGESTATE_JOBS_BASE_URL)
  }
]

onMounted(() => {
  const path = useRoute().path
  const pathArray = path.split('/').filter(Boolean)
  if (pathArray.includes(DIGESTATE_JOBS_URL)) {
    globalStore.transportActiveTab = TransportJobsType.Digestate
  } else {
    globalStore.transportActiveTab = TransportJobsType.Haulage
  }
})
</script>
<template>
  <BaseTabs :tab-items="tabs" v-model="globalStore.transportActiveTab"></BaseTabs>
</template>

<style lang="scss"></style>
